<input type="text"
       [placeholder]="placeholder"
       matInput
       [formControl]="control"
       [matAutocomplete]="autoComplete"
       (focus)="onInputFocus($event)">

<mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="displayFn">
  <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
    {{ displayFn(option) }}
  </mat-option>
</mat-autocomplete>
